import {DebuggerConsole} from '../shared/DebuggerConsole'
import {DebuggerMode, Mode} from '../shared/DebuggerMode'

// Чтобы включить отладку метрики в консоли нужно добавить параметр _ymt_debug=2 в адресной строке
// например http://example.com/?_ymt_debug=1 или http://example.com/?_ymt_debug=2

// Чтобы использовать родной для метрики логгер https://yandex.ru/support/metrica/objects/check-first-party-params.html
// (но у нас он работает нестабильно, может вызывать зависания, а также он не будет работать если метрика не будет проинициализирована)

const debuggerMode = new DebuggerMode({key: '_ymt_debug'})
const debuggerConsole = new DebuggerConsole({
  badge: 'metrika',
  badgeColor: 'hsl(65deg 20% 20%)',
  badgeBgColor: 'hsl(65deg 70% 55%)',
  collapse: debuggerMode.getMode() === Mode.ENABLED_COLLAPSE
})

/** Обертка над интерфейсом метрики, можно использовать еще до инициализации, все вызовы будут запоменены и выполнятся позже */
export const ym = Object.assign(YmFn, {
  a: createMetrikaObserverInterface(),
  l: Date.now()
})

Object.assign(window, {ym})

/** https://yandex.ru/support/metrica/objects/reachgoal.html */
function YmFn(
  id: number,
  method: 'reachGoal',
  target: string,
  params?: YmParameters,
  callback?: () => void,
  ctx?: unknown
): void
/** https://yandex.ru/support/metrica/code/counter-initialize.html */
function YmFn(id: number, method: 'init', parameters?: YmInitParams): void
/** https://yandex.ru/support/metrica/objects/addfileextension.html */
function YmFn(id: number, method: 'addFileExtension', extensions: string | string[]): void
/** https://yandex.ru/support/metrica/objects/extlink.html */
function YmFn(id: number, method: 'extLink', url: string, options?: YmOptions): void
/** https://yandex.ru/support/metrica/objects/file.html */
function YmFn(id: number, method: 'file', url: string, options?: YmOptions): void
/** https://yandex.ru/support/metrica/objects/get-client-id.html */
function YmFn(id: number, method: 'getClientID', callback: (clientId: string) => void): void
/** https://yandex.ru/support/metrica/objects/hit.html */
function YmFn(id: number, method: 'hit', url: string, options?: YmOptions): void
/** https://yandex.ru/support/metrica/objects/notbounce.html */
function YmFn(id: number, method: 'notBounce', options?: {callback?: () => void; ctx?: unknown}): void
/** https://yandex.ru/support/metrica/objects/params-method.html */
function YmFn(id: number, method: 'params', parameters: YmParameters): void
/** https://yandex.ru/support/metrica/objects/set-user-id.html */
function YmFn(id: number, method: 'setUserID', userId: string): void
/** https://yandex.ru/support/metrica/objects/user-params.html */
function YmFn(id: number, method: 'userParams', parameters: Record<string, unknown>): void
function YmFn(id: number, method: string, ...rest: unknown[]): void {
  const command = [id, method, ...rest]
  ym.a.push(command)

  if (debuggerMode.getMode() === Mode.ENABLED || debuggerMode.getMode() === Mode.ENABLED_COLLAPSE) {
    debuggerConsole
      .createGroup(String(id), [method, typeof rest[0] === 'string' ? rest[0] : undefined].filter(Boolean).join(' '))
      .log(...rest)
      .endGroup()
  }
}

function createMetrikaObserverInterface() {
  // зОчем?
  // при дефолтной инициализации метрика требует наличия массивоподобного обьекта в window.ym.a
  // пока основной код метрики не проинициализирован туда будут добавляться вызовы команд предназанченных для метрики
  // после инициализации метрика выполнит их все... НО
  // позже метрика зачем то продолжает при вызове метода вызывать оригинальный метод push у window.ym.a
  // и таким образом получается что у нас в window.ym.a будут лежать все вызовы обращений к метрике
  // что по сути утечка пямяти, если только не окажется что это зачем то нужно самой метрике
  // чтобы этого избежать мы сразу подменяем push у массива и если мы понимаем что метрика уже проинициализировалась - перестаем пушить в него
  // https://a.yandex-team.ru/arcadia/metrika/frontend/watch/src/utils/dataLayerObserver/dataLayerObserver.ts
  const ymInterface: unknown[] = []

  const pushWrap: typeof ymInterface.push = (...items) => {
    // проверяем что метод все еще оригинальный (значит метрика еще не загрузилась)
    if (ymInterface.push === pushWrap) {
      return Array.prototype.push.apply(ymInterface, items)
    }

    // метрика загрузилась, чистим массив если он не пустой и больше ничего не делаем
    if (ymInterface.length > 0) {
      ymInterface.splice(0, ymInterface.length)
    }

    return 0
  }

  ymInterface.push = pushWrap

  return ymInterface
}

type YmInitParams = {
  /** @default true */
  accurateTrackBounce?: boolean | number
  /** @default false */
  childIframe?: boolean
  /** @default true */
  clickmap?: boolean
  /** @default false */
  defer?: boolean
  /** @default false */
  trackHash?: boolean
  /** @default false */
  webvisor?: boolean
  /** @default false */
  triggerEvent?: boolean
  /** @default true */
  sendTitle?: boolean
  trustedDomains?: string[]
  /** @default true */
  trackLinks?: boolean
  /** @default false */
  ecommerce?: boolean | string | unknown[]
  params?: YmParameters
  userParams?: Record<string, unknown>
  /** @default 0 */
  type?: number
}

type YmOptions = {params?: YmParameters; referer?: string; title?: string; callback?: () => void; ctx?: unknown}

type YmParameters = {
  [x: string]: unknown
  order_price?: number
  currency?: string
}
